import { render, staticRenderFns } from "./kaiFu.vue?vue&type=template&id=2d51ddab&scoped=true&"
import script from "./kaiFu.vue?vue&type=script&lang=js&"
export * from "./kaiFu.vue?vue&type=script&lang=js&"
import style1 from "./kaiFu.vue?vue&type=style&index=1&id=2d51ddab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51ddab",
  null
  
)

export default component.exports